import * as TypeGraphQL from "type-graphql";
export var OptionsTradeExecutionScalarFieldEnum;
(function (OptionsTradeExecutionScalarFieldEnum) {
    OptionsTradeExecutionScalarFieldEnum["id"] = "id";
    OptionsTradeExecutionScalarFieldEnum["positionId"] = "positionId";
    OptionsTradeExecutionScalarFieldEnum["contractId"] = "contractId";
    OptionsTradeExecutionScalarFieldEnum["alpacaAccountId"] = "alpacaAccountId";
    OptionsTradeExecutionScalarFieldEnum["brokerOrderId"] = "brokerOrderId";
    OptionsTradeExecutionScalarFieldEnum["executionSide"] = "executionSide";
    OptionsTradeExecutionScalarFieldEnum["quantity"] = "quantity";
    OptionsTradeExecutionScalarFieldEnum["executionPrice"] = "executionPrice";
    OptionsTradeExecutionScalarFieldEnum["executionValue"] = "executionValue";
    OptionsTradeExecutionScalarFieldEnum["fees"] = "fees";
    OptionsTradeExecutionScalarFieldEnum["executionTime"] = "executionTime";
    OptionsTradeExecutionScalarFieldEnum["underlyingPriceAtExecution"] = "underlyingPriceAtExecution";
    OptionsTradeExecutionScalarFieldEnum["deltaAtExecution"] = "deltaAtExecution";
    OptionsTradeExecutionScalarFieldEnum["gammaAtExecution"] = "gammaAtExecution";
    OptionsTradeExecutionScalarFieldEnum["thetaAtExecution"] = "thetaAtExecution";
    OptionsTradeExecutionScalarFieldEnum["vegaAtExecution"] = "vegaAtExecution";
    OptionsTradeExecutionScalarFieldEnum["rhoAtExecution"] = "rhoAtExecution";
    OptionsTradeExecutionScalarFieldEnum["impliedVolatilityAtExecution"] = "impliedVolatilityAtExecution";
    OptionsTradeExecutionScalarFieldEnum["orderType"] = "orderType";
    OptionsTradeExecutionScalarFieldEnum["limitPrice"] = "limitPrice";
    OptionsTradeExecutionScalarFieldEnum["stopPrice"] = "stopPrice";
    OptionsTradeExecutionScalarFieldEnum["timeInForce"] = "timeInForce";
    OptionsTradeExecutionScalarFieldEnum["venue"] = "venue";
    OptionsTradeExecutionScalarFieldEnum["slippage"] = "slippage";
    OptionsTradeExecutionScalarFieldEnum["notes"] = "notes";
    OptionsTradeExecutionScalarFieldEnum["metadata"] = "metadata";
    OptionsTradeExecutionScalarFieldEnum["createdAt"] = "createdAt";
    OptionsTradeExecutionScalarFieldEnum["updatedAt"] = "updatedAt";
})(OptionsTradeExecutionScalarFieldEnum || (OptionsTradeExecutionScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(OptionsTradeExecutionScalarFieldEnum, {
    name: "OptionsTradeExecutionScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=OptionsTradeExecutionScalarFieldEnum.js.map